import { useFlexBox } from "../hooks/flexbox";

export default function Wrapper({ 

    children,
    direction = "vertical",
    orientation = "normal",
    position = "fill",
    gap = ".5rem",
    base = "0",
    grow = true,
    shrink = true
}) {
    const { flow, alignment } = useFlexBox();

    return (
        <div
            style={{
                flex: `${grow ? "1" : "0"} ${shrink ? "1" : "0"} ${base}`,
                display: "flex",
                flexFlow: flow[direction][orientation],
                gap: gap,
                ...alignment[direction][position]
            }}
        >
            {children}
        </div>
    )
}